import React, { useState } from 'react';
import './Emotions.css';

// Import images for fruits
// import appleImage from './images/apple.jpg';
// import bananaImage from './images/banana.jpg';
// import orangeImage from './images/orange.jpg';
// import grapesImage from './images/grapes.jpg';
// import mangoImage from './images/mango.jpg';
// import pineappleImage from './images/pineapple.jpg';
// import strawberryImage from './images/strawberry.jpg';
// import blueberryImage from './images/blueberry.jpg';
// import watermelonImage from './images/watermelon.jpg';
// import kiwiImage from './images/Kiwi.jpg';

const fruits = [
  { name: ' Gratitude', image: 'Gratitude', mind:' It is a positive emotion. A sense of thankfulness and appreciation for something received, whether tangible or intangible.' },
  { name: ' Happiness', image: 'Happiness', mind:'It is a positive emotion. A feeling of pleasure and contentment. Often experienced when something good happens' },
  { name: ' Love', image: 'Love', mind:'It is a positive emotion. A deep affection and care for someone or something.' },
  { name: ' Pride', image: 'Pride', mind:' It is a positive emotion.The feeling of satisfaction derived from ones own achievements or the achievements of those close to you.' },
  { name: ' Sadness', image: 'Sadness', mind:'It is a negative emotion. The feeling of sorrow or unhappiness, often due to loss or disappointment.' },
  { name: ' Anger', image: 'Anger', mind:'It is a negative emotion.A strong feeling of displeasure and hostility, usually in response to perceived wrongdoing.' },
  { name: ' Disgust', image: 'Disgust', mind:' It is a negative emotion.A strong feeling of aversion or disapproval, often in response to something offensive or unpleasant.' },
  { name: ' Fear', image: 'Fear', mind:' It is a negative emotion.The emotional response to a perceived threat, leading to feelings of anxiety or apprehension.' },
  
  { name: ' Jealousy', image: 'Jealousy', mind:' It is a negative emotion.The feeling of insecurity or envy toward someone elses advantages or possessions.' },
  { name: ' Curiosity', image: 'Curiosity', mind:' A desire to learn or know more about something or someone.' },
  { name: ' Surprise', image: 'Surprise', mind:'The feeling of astonishment or shock caused by something unexpected.' },
  { name: ' Empathy', image: 'Empathy', mind:' The ability to understand and share the feelings of another person.' },
  { name: ' Confusion', image: 'Confusion', mind:' A state of being puzzled or unclear about something.' },
  //   { name: 'Orange', image: orangeImage },
//   { name: 'Grapes', image: grapesImage },
//   { name: 'Mango', image: mangoImage },
//   { name: 'Pineapple', image: pineappleImage },
//   { name: 'Strawberry', image: strawberryImage },
//   { name: 'Blueberry', image: blueberryImage },
//   { name: 'Watermelon', image: watermelonImage },
//   { name: 'Kiwi', image: kiwiImage }
];

const Emotions = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.mind);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct fruit was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Learn Different Kind of Minded people</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box1"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image}  className="fruit-image1" />
            <p>{fruit.name}</p>
           
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}--{selectedFruit.mind}</div>}
      
      <h1>Find-out, which emotion state you are in...</h1>
    </div>
  );
};

export default Emotions;



